const notificationStorage = {
  state: {
    singleLeadDeleteLeads: null,
    unread_notification: 0
  },
  mutations: {
    SET_DELETE_ID_MUTATION: (state, payload) => {
      state.singleLeadDeleteLeads = payload
    },
    SET_UNREAD_MUTATION: (state, payload) => {
      
      if (payload === 'read') {
        state.unread_notification--
      } else {
        state.unread_notification = payload
      }
    }
    
  },
  actions: {
    SET_DELETE_ID: ({ commit }, payload) => {
      commit('SET_DELETE_ID_MUTATION', payload)
    },
    SET_UNREAD_NOTIFICATION_READ: ({ commit }, payload) => {
      commit('SET_UNREAD_MUTATION', payload)
    }
  
  },
  getters: {
    get_notifications_deleted_id: state => {
      return state.singleLeadDeleteLeads
    },
    get_unread_notification: state => {
      return state.unread_notification
    }
  }
}
export default notificationStorage
